var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.source + '#view=fit',"title":_vm.title,"height":"100%","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }